/**
 * @generated SignedSource<<35f1c6d06d37b6326ff2b920266a1253>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpExhibitions_nftItem$data = {
  readonly exhibitions: ReadonlyArray<{
    readonly heroBanner: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"HeroBannerItem_heroBannerItemExhibition">;
    } | null> | null;
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentType": "NftPdpExhibitions_nftItem";
};
export type NftPdpExhibitions_nftItem$key = {
  readonly " $data"?: NftPdpExhibitions_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpExhibitions_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpExhibitions_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftCmsExhibitionPage",
      "kind": "LinkedField",
      "name": "exhibitions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftCmsExhibitionHeroBannerType",
          "kind": "LinkedField",
          "name": "heroBanner",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HeroBannerItem_heroBannerItemExhibition"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "dae0fad741cf57a9595f444e460c1e02";

export default node;
